<section class="main-section">

  <!-- STICKY HEADER -->
  <div class="header-container">
    <div class="header-section">
      <div class="header-left">
        <div class="header-title">Add Page</div>
        <span class="page-count-badge">{{ filteredPageList.length + 1 }}</span>
      </div>
      <div class="header-right d-flex align-items-center gap-3">
        <mat-form-field class="filter-field input_card" appearance="outline">
          <mat-select
            multiple
            placeholder="Filter by type..."
            (selectionChange)="getSelectedPages($event)"
            #industrySelectElement>
            <div class="search-container">
              <input
                type="text"
                matInput
                placeholder="Search..."
                [(ngModel)]="pageSearch"
                class="search-input"
                (ngModelChange)="searchPage()" />
            </div>
            <ng-container *ngIf="industryWisePages.length > 0">
              <mat-option *ngFor="let industry of filteredPages" [value]="industry">
                {{ industry.name | titlecase }}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
        <button class="close-btn" (click)="closeBtn()" type="button">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <div class="header-divider"></div>
  </div>

  <!-- PAGE GRID -->
  <div class="page-grid">

    <!-- Dynamic pages from API -->
    <ng-container *ngFor="let page of filteredPageList">
      <div class="page-card" (click)="addPage(page)">
        <div class="page-preview">
          <div class="wireframe">
            <div class="wf-nav"></div>
            <div class="wf-hero"></div>
            <div class="wf-line wf-line--wide"></div>
            <div class="wf-line wf-line--medium"></div>
            <div class="wf-columns">
              <div class="wf-col"></div>
              <div class="wf-col"></div>
            </div>
          </div>
        </div>
        <div class="page-card-footer">
          <div class="page-name">{{ page.pageName }}</div>
          <button class="add-btn" type="button">Add</button>
        </div>
      </div>
    </ng-container>

    <!-- Blank Page — visually distinct -->
    <div class="page-card page-card--blank" (click)="addBlankPage()">
      <div class="page-preview page-preview--blank">
        <div class="blank-icon-wrap">
          <mat-icon class="blank-plus-icon">add_circle_outline</mat-icon>
          <span class="blank-hint">Start from scratch</span>
        </div>
      </div>
      <div class="page-card-footer">
        <div class="page-name">Blank Page</div>
        <button class="add-btn add-btn--blank" type="button">Add</button>
      </div>
    </div>

  </div>
</section>
